import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import ITokenData from "../../../src/server/data/ITokenData";

export default class TokenDataParser implements IBaseDataParser<ITokenData> {
    check(data: any): boolean {
        return data.status == "ok" && data.response;
    }

    parse(data: ITokenData): any[] {
        ////    response: {remoteusername: "Sasho", replaytoken: "mmcl6i50kq71yz9uaj7rcbqh", servertime: 1584537386,…}
        // // remoteusername: "Sasho"
        // // replaytoken: "mmcl6i50kq71yz9uaj7rcbqh"
        // // servertime: 1584537386
        // // token: "09or7sp5o46d2m5s"
        // // userid: "10000000000e6bf5"
        // // status: "ok"
        const result = {
            playerConfig: {
                name: data.response.remoteusername,
                userId: data.response.userid,
            },
            playerToken: data.response.token,
            replayToken: data.response.replaytoken,
        };

        return [result];
    }
}
